export default __webpack_public_path__ + "static/media/grafema_SET_9.7059216e.jpg";